export const createTACStyles = (tac: string, iframe: any) => {
    if (!iframe) return;
    const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
    if (iframeDoc) {
        iframeDoc.open();
        iframeDoc.close();
        iframeDoc.body.innerHTML = tac;
    }
    if (iframe?.contentWindow?.document?.body?.innerHTML) {
        iframe.contentWindow.document.head.innerHTML = `
                ${iframe.contentWindow.document.head.innerHTML}
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
                <link href="https://fonts.googleapis.com/css2?family=Marcellus&display=swap" rel="stylesheet" />
                <link
                    href="https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,600;0,700;0,800;1,300;1,400;1,600;1,700;1,800&display=swap"
                    rel="stylesheet"
                />
            `;
        iframe.contentWindow.document.body.innerHTML = `${
            iframe.contentWindow.document.body.innerHTML.split(`<style>`)?.[0]
        }${iframe.contentWindow.document.body.innerHTML.split(`</style>`)?.[1]}<style>${`
            * {
                /*font-family: Open Sans !important;*/
                color: #323232 !important;
            }
            body {
                padding: 80px 125px;
            }
            @media (max-width: 991px) {
                body {
                    padding: 20px 10px;
                }
            }
            .c5 {
                font-weight: bold;
                font-size: 40px;
                line-height: 54px;
            }
            .c0 {
                font-size: 18px;
                line-height: 25px;
                font-weight: bold;
                margin-bottom: 10px;
            }
            .c1 {
                font-size: 18px;
                line-height: 25px;
                font-style: normal;
            }
        `}</style>`;
    }
};
